import {Component, Inject} from '@angular/core';
import {CodeType, ProgressInfos} from "../../../../../../lib/models/code.model";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {GROUP_ID_TEMPLATE} from "../../../../../../lib/services/tools.service";
import {CodeService} from "../../../../../../lib/services/code.service";
import {TarificationService} from "../../../../../../lib/services/tarification.service";
import {AbstractFilterCode, Code, CodeByRegionTypeLabelLanguageFilter} from "@icure/api";
import {AbstractFilterTopic} from "@icure/api/icc-api/model/AbstractFilterTopic";
import {UtilsService} from "../../../../../../lib/services/utils.service";
import {InsuranceService} from "../../../../../../lib/services/insurance.service";

interface ngOnInit {
}

export const IN_PROGRESS = 'IN_PROGRESS';
export const COMPLETED = 'COMPLETED';
export const ERROR = 'ERROR';
export const WAITING = 'WAITING';

@Component({
  selector: 'ms-code-importation-dialog',
  templateUrl: './code-importation-dialog.component.html',
  styleUrl: './code-importation-dialog.component.scss',
  standalone: false
})
export class CodeImportationDialogComponent implements ngOnInit {

  allCodeTypes: CodeType[] = [
    {
      id: "BE-THESAURUS",
      type: "BE-THESAURUS",
      version: "3.1.0",
      category: "thesaurus",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "BE-THESAURUS-PROCEDURES",
      type: "BE-THESAURUS-PROCEDURES",
      version: "3.1.2",
      category: "thesaurus",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "BE-THESAURUS-SURGICAL-PROCEDURES",
      type: "BE-THESAURUS-SURGICAL-PROCEDURES",
      version: "1.1.0",
      category: "thesaurus",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "ISO-639-1",
      type: "ISO-639-1",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "BE-ALLERGEN",
      type: "BE-ALLERGEN",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "BE-CITY",
      type: "BE-CITY",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "BE-CONTACT-TYPE",
      type: "BE-CONTACT-TYPE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "BE-COUNTRY",
      type: "BE-COUNTRY",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "BE-FAMILY-LINK",
      type: "BE-FAMILY-LINK",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "BE-MUNICIPALITY",
      type: "BE-MUNICIPALITY",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "BE-POSTCODES",
      type: "BE-POSTCODES",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "BE-PRIMARY-INCOME-SOURCE",
      type: "BE-PRIMARY-INCOME-SOURCE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "BE-PROFESSION-TYPE",
      type: "BE-PROFESSION-TYPE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "BE-SKILLS-CODES",
      type: "BE-SKILLS-CODES",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "BE-SOCIAL-STATUS",
      type: "BE-SOCIAL-STATUS",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-ACKNOWLEDGMENT",
      type: "CD-ACKNOWLEDGMENT",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-ADDRESS",
      type: "CD-ADDRESS",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-ADMINISTRATIONUNIT",
      type: "CD-ADMINISTRATIONUNIT",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-ATC_01",
      type: "CD-ATC",
      version: "1.0",
      category: "default",
      active: false,
      selected: false,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-ATC_02",
      type: "CD-ATC",
      version: "1.1",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-ATC_03",
      type: "CD-ATC",
      version: "1.2.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-BALLON-DEVICE",
      type: "CD-BALLON-DEVICE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-BEARING-SURFACE",
      type: "CD-BEARING-SURFACE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-BVT-AVAILABLEMATERIALS",
      type: "CD-BVT-AVAILABLEMATERIALS",
      version: "1.0",
      category: "default",
      active: false,
      selected: false, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-BVT-CONSERVATIONDELAY",
      type: "CD-BVT-CONSERVATIONDELAY",
      version: "1.0",
      category: "default",
      active: false,
      selected: false, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-BVT-CONSERVATIONMODE",
      type: "CD-BVT-CONSERVATIONMODE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-BVT-LATERALITY",
      type: "CD-BVT-LATERALITY",
      version: "1.0",
      category: "default",
      active: false,
      selected: false, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-BVT-PATIENTOPPOSITION",
      type: "CD-BVT-PATIENTOPPOSITION",
      version: "1.0",
      category: "default",
      active: false,
      selected: false, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-BVT-SAMPLETYPE",
      type: "CD-BVT-SAMPLETYPE",
      version: "1.0",
      category: "default",
      active: false,
      selected: false, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-BVT-STATUS",
      type: "CD-BVT-STATUS",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-CAREPATH",
      type: "CD-CAREPATH",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-CERTAINTY",
      type: "CD-CERTAINTY",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-CLINICAL",
      type: "CD-CLINICAL",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-CLINICALPLAN",
      type: "CD-CLINICALPLAN",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-CONSENT",
      type: "CD-CONSENT",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-CONTACT-PERSON",
      type: "CD-CONTACT-PERSON",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-CURRENCY",
      type: "CD-CURRENCY",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-DAYPERIOD",
      type: "CD-DAYPERIOD",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-DIARY",
      type: "CD-DIARY",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-DIFFERENTIATIONDEGREE",
      type: "CD-DIFFERENTIATIONDEGREE",
      version: "1.0",
      category: "default",
      active: false,
      selected: false, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-DISCHARGETYPE",
      type: "CD-DISCHARGETYPE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-DRUG-CNK",
      type: "CD-DRUG-CNK",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-DRUG-PRESENTATION",
      type: "CD-DRUG-PRESENTATION",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-DRUG-ROUTE_V10",
      type: "CD-DRUG-ROUTE",
      version: "1.0",
      category: "default",
      active: false,
      selected: false, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-DRUG-ROUTE_V21",
      type: "CD-DRUG-ROUTE",
      version: "2.1",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-EBIRTH-ARTIFICIALRESPIRATIONTYPE",
      type: "CD-EBIRTH-ARTIFICIALRESPIRATIONTYPE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-EBIRTH-CAESEREANINDICATION",
      type: "CD-EBIRTH-CAESEREANINDICATION",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-EBIRTH-CHILDPOSITION",
      type: "CD-EBIRTH-CHILDPOSITION",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-EBIRTH-CONGENITALMALFORMATION",
      type: "CD-EBIRTH-CONGENITALMALFORMATION",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-EBIRTH-DELIVERYWAY",
      type: "CD-EBIRTH-DELIVERYWAY",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-EBIRTH-FOETALMONITORING",
      type: "CD-EBIRTH-FOETALMONITORING",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-EBIRTH-NEONATALDEPTTYPE",
      type: "CD-EBIRTH-NEONATALDEPTTYPE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-EBIRTH-PLACE",
      type: "CD-EBIRTH-PLACE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-EBIRTH-PREGNANCYORIGIN",
      type: "CD-EBIRTH-PREGNANCYORIGIN",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-EBIRTH-SPECIALVALUES",
      type: "CD-EBIRTH-SPECIALVALUES",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-EMERGENCYEVALUATION",
      type: "CD-EMERGENCYEVALUATION",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-ENCOUNTER",
      type: "CD-ENCOUNTER",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-ENCOUNTERSAFETYISSUE",
      type: "CD-ENCOUNTERSAFETYISSUE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-ENCRYPTION-ACTOR",
      type: "CD-ENCRYPTION-ACTOR",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-EXTERNALSOURCE",
      type: "CD-EXTERNALSOURCE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-FED-COUNTRY",
      type: "CD-FED-COUNTRY",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-FORMULARY",
      type: "CD-FORMULARY",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-GYNECOLOGY",
      type: "CD-GYNECOLOGY",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-HCPARTY",
      type: "CD-HCPARTY",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-HEADING",
      type: "CD-HEADING",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-HEADING-REG",
      type: "CD-HEADING-REG",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-IMPLANTATION-DEVICE",
      type: "CD-IMPLANTATION-DEVICE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-IMPLANTATION-TYPE",
      type: "CD-IMPLANTATION-TYPE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-INCAPACITY",
      type: "CD-INCAPACITY",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-INCAPACITYREASON",
      type: "CD-INCAPACITYREASON",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-INNCLUSTER",
      type: "CD-INNCLUSTER",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-ITEM",
      type: "CD-ITEM",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-ITEM-EBIRTH",
      type: "CD-ITEM-EBIRTH",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-ITEM-MAA",
      type: "CD-ITEM-MAA",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-ITEM-MS",
      type: "CD-ITEM-MS",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-ITEM-MYCARENET",
      type: "CD-ITEM-MYCARENET",
      version: "1.0",
      category: "default",
      active: false,
      selected: false,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-ITEM-REG",
      type: "CD-ITEM-REG",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-LAB", type: "CD-LAB", version: "1.0", category: "default", active: true, selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-LEGAL-SERVICE",
      type: "CD-LEGAL-SERVICE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-LIFECYCLE",
      type: "CD-LIFECYCLE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-LNK", type: "CD-LNK", version: "1.0", category: "default", active: true, selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-MAA-COVERAGETYPE",
      type: "CD-MAA-COVERAGETYPE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-MAA-REFUSALJUSTIFICATION",
      type: "CD-MAA-REFUSALJUSTIFICATION",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-MAA-REQUESTTYPE",
      type: "CD-MAA-REQUESTTYPE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-MAA-RESPONSETYPE",
      type: "CD-MAA-RESPONSETYPE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-MAA-TYPE",
      type: "CD-MAA-TYPE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-MAGISTRALFORM",
      type: "CD-MAGISTRALFORM",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-MEDIATYPE",
      type: "CD-MEDIATYPE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-MESSAGE",
      type: "CD-MESSAGE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-MKG-ADMISSION",
      type: "CD-MKG-ADMISSION",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-MKG-DESTINATION",
      type: "CD-MKG-DESTINATION",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-MKG-DISCHARGE",
      type: "CD-MKG-DISCHARGE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-MKG-ORIGIN",
      type: "CD-MKG-ORIGIN",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-MKG-REFERRER",
      type: "CD-MKG-REFERRER",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-MS-ADAPTATION",
      type: "CD-MS-ADAPTATION",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-MS-MEDICATIONTYPE",
      type: "CD-MS-MEDICATIONTYPE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-MS-ORIGIN",
      type: "CD-MS-ORIGIN",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-ORTHO-APPROACH",
      type: "CD-ORTHO-APPROACH",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-ORTHO-DIAGNOSIS",
      type: "CD-ORTHO-DIAGNOSIS",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-ORTHO-GRAFT",
      type: "CD-ORTHO-GRAFT",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-ORTHO-INTERFACE",
      type: "CD-ORTHO-INTERFACE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-ORTHO-KNEE-INSERT",
      type: "CD-ORTHO-KNEE-INSERT",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-ORTHO-NAVCOM",
      type: "CD-ORTHO-NAVCOM",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-ORTHO-TECHREVISION",
      type: "CD-ORTHO-TECHREVISION",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-ORTHO-TYPE",
      type: "CD-ORTHO-TYPE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-PARAMETER",
      type: "CD-PARAMETER",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-PATIENTWILL",
      type: "CD-PATIENTWILL",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-PATIENTWILL-HOS",
      type: "CD-PATIENTWILL-HOS",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-PATIENTWILL-RES",
      type: "CD-PATIENTWILL-RES",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-PERIODICITY",
      type: "CD-PERIODICITY",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-PROOFTYPE",
      type: "CD-PROOFTYPE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-QUANTITYPREFIX",
      type: "CD-QUANTITYPREFIX",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-REFSCOPE",
      type: "CD-REFSCOPE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-REIMBURSEMENT-NOMENCLATURE",
      type: "CD-REIMBURSEMENT-NOMENCLATURE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-REIMBURSEMENT-RECIPE",
      type: "CD-REIMBURSEMENT-RECIPE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-REV-COMPONENT",
      type: "CD-REV-COMPONENT",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-SEVERITY",
      type: "CD-SEVERITY",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-SEX", type: "CD-SEX", version: "1.0", category: "default", active: true, selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-SITE",
      type: "CD-SITE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-STANDARD",
      type: "CD-STANDARD",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-TECHNICAL",
      type: "CD-TECHNICAL",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-TELECOM",
      type: "CD-TELECOM",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-TEMPORALITY",
      type: "CD-TEMPORALITY",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-THERAPEUTICLINKTYPE",
      type: "CD-THERAPEUTICLINKTYPE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-TIMEUNIT",
      type: "CD-TIMEUNIT",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-TRANSACTION_V114",
      type: "CD-TRANSACTION",
      version: "1.1.4",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-TRANSACTION_V117",
      type: "CD-TRANSACTION",
      version: "1.1.7",
      category: "default",
      active: false,
      selected: false, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-TRANSACTION-MAA",
      type: "CD-TRANSACTION-MAA",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-TRANSACTION-MYCARENET",
      type: "CD-TRANSACTION-MYCARENET",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-TRANSACTION-REG",
      type: "CD-TRANSACTION-REG",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-TRANSACTION-TYPE",
      type: "CD-TRANSACTION-TYPE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-UNIT",
      type: "CD-UNIT",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-URGENCY",
      type: "CD-URGENCY",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-VACCINE",
      type: "CD-VACCINE",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-VACCINEINDICATION",
      type: "CD-VACCINEINDICATION",
      version: "1.0",
      category: "default",
      active: true,
      selected: true, progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "CD-WEEKDAY",
      type: "CD-WEEKDAY",
      version: "1.0",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "TARIFICATION",
      type: "TARIFICATION",
      version: "1.0",
      category: "tarification",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "INSURANCE",
      type: "INSURANCE",
      version: "1.0",
      category: "insurance",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "ICD",
      type: "ICD",
      version: "10",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
    {
      id: "ICPC",
      type: "ICPC",
      version: "2",
      category: "default",
      active: true,
      selected: true,
      progressInfos: {
        injectedCode: 0,
        updatedCode: 0,
        status: "WAITING"
      }
    },
  ];

  public availableDefaultCodeTypes: CodeType[] = [];
  public availableThesaurusCodeTypes: CodeType[] = [];
  public availableInsuranceCodeTypes: CodeType[] = [];
  public availableTarificationCodeTypes: CodeType[] = [];
  public isLoading: boolean = false;
  public isImporting: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<CodeImportationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private codeService: CodeService,
    private tarificationService: TarificationService,
    private insuranceService: InsuranceService
  ) {
    dialogRef.disableClose = true;
  }

  protected readonly COMPLETED = COMPLETED;
  protected readonly WAITING = WAITING;
  protected readonly IN_PROGRESS = IN_PROGRESS;
  protected readonly ERROR = ERROR;

  ngOnInit(): void {
    this.availableDefaultCodeTypes = this.allCodeTypes.filter(ct => ct.active && (ct.category === 'default' || ct.category === 'iso'));
    this.availableThesaurusCodeTypes = this.allCodeTypes.filter(ct => ct.active && ct.category === 'thesaurus');
    this.availableInsuranceCodeTypes = this.allCodeTypes.filter(ct => ct.active && ct.category === 'insurance');
    this.availableTarificationCodeTypes = this.allCodeTypes.filter(ct => ct.active && ct.category === 'tarification');

    console.log(this.data);
    console.log(GROUP_ID_TEMPLATE)
  }

  public closeDialog() {
    this.isLoading = false;
    this.isImporting = false;
    this.dialogRef.close();
  }

  public checkAll(checked: boolean, type: string): void {
    if (type === 'thesaurus') {
      this.availableThesaurusCodeTypes = this.availableThesaurusCodeTypes.map(code => ({
        ...code,
        selected: checked
      }));
    }
    if (type === 'insurance') {
      this.availableInsuranceCodeTypes = this.availableInsuranceCodeTypes.map(code => ({
        ...code,
        selected: checked
      }));
    }
    if (type === 'tarification') {
      this.availableTarificationCodeTypes = this.availableTarificationCodeTypes.map(code => ({
        ...code,
        selected: checked
      }));
    }
    if (type === 'default') {
      this.availableDefaultCodeTypes = this.availableDefaultCodeTypes.map(code => ({
        ...code,
        selected: checked
      }));
    }

  }

  public async importSelectedCodes() {
    this.isLoading = true;
    this.isImporting = true;
    if (this.availableThesaurusCodeTypes?.filter(ct => ct.selected).length) {
      const codesToImport = this.availableThesaurusCodeTypes.filter(ct => ct.selected);
      for (let codeType of codesToImport) {
        this.updateProgressInfo(codeType?.category, codeType.type, 0, 0, IN_PROGRESS);
        const infos = await this.codeService.injectCodeIntoDb(this.data.selectedGroup.id, codeType.type)
        this.updateProgressInfo(codeType?.category, codeType.type, infos?.injectedCodes, infos?.updatedCodes, COMPLETED);
      }
    }

    if (this.availableInsuranceCodeTypes?.filter(ct => ct.selected).length) {
      const insuranceToImport = this.availableInsuranceCodeTypes.filter(ct => ct.selected);
      for (let codeType of insuranceToImport) {
        this.updateProgressInfo(codeType?.category, codeType.type, 0, 0, 'IN_PROGRESS');
        const infos = await this.insuranceService.injectInsuranceIntoDb(this.data.selectedGroup.id)
        this.updateProgressInfo(codeType?.category, codeType.type, infos?.injectedCodes, infos?.updatedCodes, 'COMPLETED');
      }
    }


    if (this.availableTarificationCodeTypes?.filter(ct => ct.selected).length) {
      const tarificationToImport = this.availableTarificationCodeTypes.filter(ct => ct.selected);
      for (let codeType of tarificationToImport) {
        this.updateProgressInfo(codeType?.category, codeType.type, 0, 0, IN_PROGRESS);
        const infos = await this.tarificationService.injectTarificationIntoDb(this.data.selectedGroup.id)
        this.updateProgressInfo(codeType?.category, codeType.type, infos?.injectedCodes, infos?.updatedCodes, COMPLETED);
      }
    }

    if (this.availableDefaultCodeTypes?.filter(ct => ct.selected).length) {
      const codesToImport = this.availableDefaultCodeTypes.filter(ct => ct.selected);
      for (let codeType of codesToImport) {
        this.updateProgressInfo(codeType?.category, codeType.type, 0, 0, IN_PROGRESS);
        const infos = await this.codeService.injectCodeIntoDb(this.data.selectedGroup.id, codeType.type)
        this.updateProgressInfo(codeType?.category, codeType.type, infos?.injectedCodes, infos?.updatedCodes, infos?.status);
      }
    }
    this.isLoading = false;
  }

  private updateProgressInfo(category: string, codeType: string, injectedCode: number, updatedCode: number, status: string) {
    const selectedCode =
      category === 'thesaurus' ?
        this.availableThesaurusCodeTypes.find(c => c.type === codeType) :
        category === 'default' ?
          this.availableDefaultCodeTypes.find(c => c.type === codeType) :
          category === 'insurance' ?
            this.availableInsuranceCodeTypes.find(c => c.type === codeType) :
            category === 'tarification' ? this.availableTarificationCodeTypes.find(c => c.type === codeType) : null;

    // @ts-ignore
    selectedCode.progressInfos.injectedCode = injectedCode
    // @ts-ignore
    selectedCode.progressInfos.updatedCode = updatedCode
    // @ts-ignore
    selectedCode.progressInfos.status = status
  }

  public getStatusHr(status: string): string {
    switch (status) {
      case 'WAITING':
        return 'En attente';
      case IN_PROGRESS:
        return 'En cours';
      case COMPLETED:
        return 'Terminé';
      case 'ERROR':
        return 'En erreur';
      default:
        return '';
    }
  }

  public getCounterByStatus(status: string[]): number {
    return this.availableThesaurusCodeTypes?.filter(c => c.selected && status.includes(c.progressInfos.status)).length +
      this.availableDefaultCodeTypes?.filter(c => c.selected && status.includes(c.progressInfos.status)).length +
      this.availableInsuranceCodeTypes?.filter(c => c.selected && status.includes(c.progressInfos.status)).length +
      this.availableTarificationCodeTypes?.filter(c => c.selected && status.includes(c.progressInfos.status)).length;
  }

  public getTotalCounter(): number {
    return this.availableThesaurusCodeTypes?.filter(c => c.selected).length +
      this.availableDefaultCodeTypes?.filter(c => c.selected).length +
      this.availableInsuranceCodeTypes?.filter(c => c.selected).length +
      this.availableTarificationCodeTypes?.filter(c => c.selected).length;
  }

  public allCodesChecked(type: string): boolean {
    return type === 'thesaurus' ? this.availableThesaurusCodeTypes?.filter(c => c.active)?.length === this.availableThesaurusCodeTypes?.filter(c => c.selected && c.active).length :
      type === 'insurance' ? this.availableInsuranceCodeTypes?.filter(c => c.active)?.length === this.availableInsuranceCodeTypes?.filter(c => c.selected && c.active).length :
        type === 'default' ? this.availableDefaultCodeTypes?.filter(c => c.active)?.length === this.availableDefaultCodeTypes?.filter(c => c.selected && c.active).length :
          type === 'tarification' ? this.availableTarificationCodeTypes?.filter(c => c.active)?.length === this.availableTarificationCodeTypes?.filter(c => c.selected && c.active).length :
            false;
  }


}
